let shareLink = null;
let shareLinkConfirmation = null;

export const shareLinks = {
    onDocumentLoad
}

const onDocumentLoad = function() {
  /*Share link*/
  shareLink = document.getElementById("shareLink");
  shareLinkConfirmation = document.getElementById("shareLinkConfirmation");
  if (shareLink) {
    shareLink.addEventListener("click", function (e) {
      navigator.clipboard.writeText(window.location.href);
      setTimeout(() => {
        shareLinkConfirmation.classList.remove("hidden");
      }, 250);
      setTimeout(() => {
        shareLinkConfirmation.classList.add("hidden");
      }, 3250);
    });
  }
}